<template>
  <v-main class="pa-0" align-content="center">
    <div class="mx-5">削除するフォルダを選択してください</div>
    <div class="mx-5">所属していたLidは削除されず、フォルダ格納前の位置に戻ります</div>
    <v-divider></v-divider>
    <v-radio-group v-model="delfolder">
      <v-radio
        class="ma-0"
        v-for="item in myfolder"
        :key="item.id"
        :value="item.id"
        :label="`- ${item.title}`"
      ></v-radio>
    </v-radio-group>

    <v-btn
      tile
      width="200"
      elevation="0"
      color="#008CFF"
      class="white--text my-5"
      @click="delfolderfunc()"
    >
      フォルダを削除
    </v-btn>
  </v-main>
</template>
      <script>
import firebase from "firebase/app";
import "firebase/firestore";
export default {
  data() {
    return {
      db: firebase.firestore(),
      numlid: 0,
      folderName: "",
      tagColors: ["#2B2B2B"],
      tagNames: ["フォルダー"],
      delfolder:null
    };
  },
  created() {
    this.numlid = this.lid.length;
  },
  computed: {
    lid() {
      return this.$store.state.lid;
    },
    navlid() {
      // ナビゲーター用
      // Lid - childlid +folder
      return this.$store.state.navlid;
    },
    myfolder() {
      // folder一覧

      // let availablelid = [];
      // this.navlid.forEach(function (item) {
      //   if (item.isfolder == true) {
      //     availablelid.push(item);
      //   }
      // });
      // return availablelid;

      // mapで書き直す
      return this.navlid.filter((item) => item.isfolder);
    },
  },
  methods: {
    delfolderfunc(){
      this.cleanfolder().then(()=>{
        this.$store.dispatch("getLid");
      })
    },
    cleanfolder() {
      const self = this;
      console.log(this.delfolder);
      // 属していたLidたちを解放
      // this.myfolder[this.delfolder].childrenid.forEach(function (item) {
      this.myfolder.find((item) => item.id == this.delfolder).childrenid.forEach(function (childrenitem) {
        self.db
          .collection("0")
          .doc(childrenitem)
          .update(
            {
              ischild: false,
            },
            { merge: true }
          )
          .then(function () {})
          .catch(function (error) {
            console.error("Error Save ischild: ", error);
          });
      });
      // フォルダーを無効化
      this.db
        .collection("0")
        .doc(this.delfolder)
        .update(
          {
            isActive: false,
          },
          { merge: true }
        )
        .then(function () {})
        .catch(function (error) {
          console.error("Error Save ischild: ", error);
        });
    },
  },
};
</script>
      